import React, { useContext, useState } from 'react';
import {
  Stack,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from '@mui/material';
import {
  Close,
  SupervisorAccount as SupervisorAccountIcon,
} from '@mui/icons-material';

import HaveMoreLocations from '@features/profile/components/HaveMoreLocations/HaveMoreLocations';
import { white } from '@styles/colors';
import { track } from '@amplitude/analytics-browser';
import { amplitudeEventsName } from '@utils/amplitudeEvents';
import { useUpdateProfile } from '@features/profile/hooks/useUpdateProfile';
import { LoadingButton } from '@mui/lab';
import { useRequestEnterpriseInfo } from '@features/payments/hooks/useRequestEnterpriseInfo';
import { authContext } from '@staffedupusa/shared-components';

const AskMoreLocations: React.FC = () => {
  const { authData } = useContext(authContext);
  const [isReqInfoModalOpen, setIsReqInfoModalOpen] = useState<boolean>(false);
  const [errorText, setErrorText] = React.useState<string>('');

  const { updateProfile, isUpdatingProfile } = useUpdateProfile({});
  const { requestEnterpriseInfo } = useRequestEnterpriseInfo({ setErrorText });

  const handleCloseModal = () => {
    updateProfile({ has_more_locations_answered: true });
    requestEnterpriseInfo({
      company_name: authData?.user?.company?.s_name || '',
    });
    setIsReqInfoModalOpen((prev) => !prev);
  };

  const handleYesClick = () => {
    track(amplitudeEventsName.MORE_LOCATIONS_YES_CLICKED);
    setIsReqInfoModalOpen(true);
  };

  const handleNoClick = () => {
    updateProfile({ has_more_locations_answered: true });
    track(amplitudeEventsName.MORE_LOCATIONS_NO_CLICKED);
  };

  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
        bgcolor={white}
        p={2}
        borderRadius={8}
        width="100%"
        sx={{ marginBottom: '10px' }}
      >
        <Typography
          fontSize="14px"
          variant="body1"
          fontWeight="bold"
          lineHeight={1}
          textAlign="start"
        >
          Do you have more locations?
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center">
          <LoadingButton
            loading={isUpdatingProfile}
            variant="contained"
            sx={{ fontSize: '12px', minWidth: '50px', padding: '0 !important' }}
            onClick={handleYesClick}
          >
            Yes
          </LoadingButton>
          <LoadingButton
            loading={isUpdatingProfile}
            variant="outlined"
            sx={{ fontSize: '12px', minWidth: '50px', padding: '0 !important' }}
            onClick={handleNoClick}
          >
            No
          </LoadingButton>
        </Stack>
      </Stack>

      <Dialog
        open={isReqInfoModalOpen}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle textAlign="center">
          <IconButton
            sx={{ position: 'absolute', top: 10, right: 10 }}
            onClick={handleCloseModal}
          >
            <Close />
          </IconButton>
          <br />
          <SupervisorAccountIcon
            sx={{
              fontSize: 60,
              color: 'primary.main',
              margin: 'auto !important',
            }}
          />
        </DialogTitle>
        <DialogContent>
          <HaveMoreLocations
            isModalContent
            handleClose={() => {
              setIsReqInfoModalOpen(false);
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AskMoreLocations;
